import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CounterState {
  value: number;
}
/// ข้อ 1 สร้างค่าเริ่มต้น
const initialState = { value: 5 } as CounterState;
/// ข้อ 2 สร้าง func สำหรับแก้ไขข้อมูล
const testSlice = createSlice({
  // **กำหนดชื่อ
  name: "test",

  // **เอาค่าเริ่มต้นมาใส่
  initialState,

  // **สร้าง reducers:{ ข้างในจะเป็น func สำหรับแก้ไขข้อมูล}
  reducers: {
    increment(state) {
      state.value++;
    },
    decrement(state) {
      state.value--;
    },
    incrementByAmount(state, action: PayloadAction<number>) {
      state.value += action.payload;
    },
  },
});

//export ให้ที่อื่นนำไปใช้ func
export const { increment, decrement, incrementByAmount } = testSlice.actions;
// export default store;
export default testSlice.reducer;
